var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2968",
    "data-name": "Group 2968",
    transform: "translate(-728 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_98",
    "data-name": "Polygon 98",
    d: "M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z",
    transform: "translate(728 231)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_99",
    "data-name": "Polygon 99",
    d: "M3.7,1.067a1,1,0,0,1,1.6,0L7.8,4.4A1,1,0,0,1,7,6H2a1,1,0,0,1-.8-1.6Z",
    transform: "translate(737 245) rotate(180)",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sortingIcon.7a34c58b49a07dd669a5433dba4da263.svg";
export { ForwardRef as ReactComponent };